import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	titleText: {
		fontSize: "24px",
		fontWeight: 600,
		color: colors.gray[600]
	},
	dateInput: {
		paddingLeft: "0px",
		marginRight: "0px",
		height: "56px"
	},
	searchButton: {
		height: "55px"
	}
}))

export default useStyles
